import { NgClass, NgOptimizedImage } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core'
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { RouterLink } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'

import type { Requirement } from '../../util/validators'
import { PasswordRequirementsComponent } from '../password-requirements/password-requirements.component'

@Component({
  selector: 'dhp-create-account-fields',
  templateUrl: './create-account-fields.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    NgOptimizedImage,
    ReactiveFormsModule,
    RouterLink,
    TranslatePipe,
    PasswordRequirementsComponent,
  ],
})
export class CreateAccountFieldsComponent {
  readonly formGroup = input.required<FormGroup>()
  readonly creationFailed = input(false)
  readonly requirements = input<Requirement[]>([])

  readonly firstNameControl = computed(
    () => this.formGroup().controls['first_name'] as FormControl<string | null>
  )

  readonly lastNameControl = computed(
    () => this.formGroup().controls['last_name'] as FormControl<string | null>
  )

  readonly usernameControl = computed(
    () => this.formGroup().controls['username'] as FormControl<string | null>
  )
}
